import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./stulogin.css";
import { Link } from "react-router-dom";
import { useUser } from "../../../context/UserContext"; // adjust path if needed
import Swal from "sweetalert2";
 

const Stu_verify = () => {
  const { setUser } = useUser();
  const [otp, setOtp] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone || ""; // phone passed from previous page

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://topfaculty.co.in/api/stuotp_verify.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ phone, otp }),
      });

      const result = await response.json();
      console.log("OTP Verify Result:", result);

      if (result.success === 1) {
        const token = result.token;
        const decoded = parseJwt(token.split(" ")[1]);

        // Store token and user
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("user", JSON.stringify(decoded.data));

        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(decoded.data));

        // Set context
        setUser(decoded);

        Swal.fire("Success", result.message, "success").then(() => {
          navigate("/"); // redirect to homepage
        });
      } else {
        Swal.fire("Error", result.message, "error");
      }
    } catch (error) {
      console.error("OTP Verify Error:", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

   
  return (
    <>
      <div id="rs-latest-news" className="rs-courses-details">
        <img
          src="assetsfront/images/stulogin.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />
        <div className="container">
          <div className="row rs-latest-list">
            <h2 className="title text-center  mt-4 ">
              Student : <span class="info-color">Verify OTP </span>
            </h2>
          </div>
          <div className="row">
            <div className="col-md-3"></div>

            <div className="col-md-6">
              <div className=" ">
                <div className="container h-100">
                  <div className="row h-100 justify-content-center align-items-center">
                    <form
                      className="col-md-12"
                       method="post"
                       onSubmit={handleVerifyOtp} 
                    >
                      <div
                        className="AppForm shadow-lg"
                        style={{
                          borderLeft: "5px solid #c5c5c5",
                          borderRadius: "12px",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-12  p-4 align-items-center ">
                            <div className="AppFormLeft">
                              {/* <h1 className="text-center">Login</h1> */}
                              <div className="form-group position-relative mb-4">
                                <img
                                  src="https://thumbs.dreamstime.com/b/innovative-cybersecurity-banner-virtual-shield-motifs-350050674.jpg"
                                 style={{width:"100%",height:"190px"}}
                                ></img>

                                <label
                                  className="form-label"
                                  style={{ color: "black",marginTop: "10px" }}
                                >
                                  OTP sent to {phone} 
                                </label>
                                <input
                                  className="form-control "
                                  type="number"
                                    placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
                                />
                              </div>

                              <button
                                type="submit"
                                className="btn btn-success btn-block shadow border-0 py-2 text-uppercase "
                              >
                                Verify
                              </button>
                              <p className="text-center mt-5">
                                Don't have an account?
                                <Link to={"../studentregister"}>
                                  {" "}
                                  <span>Create your account</span>
                                </Link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stu_verify;
